<sui-dialog-header class="header" (closeButtonClick)="_onCloseButtonClick()"
  >내 메모로 복사하기</sui-dialog-header
>
<div class="body">
  <div class="text-container">
    <div class="description">복사한 댓글은 '나의책'의 메모로 저장됩니다.</div>
  </div>

  <viewer-memo [limitHeight]="false" [content]="_data.content"></viewer-memo>
  <div class="actions">
    <button
      sui-solid-button
      varSize="medium40::large"
      (click)="_onCopyButtonClick()"
    >
      복사하기
    </button>
  </div>
</div>
